
const DEFAULT_GRADIENT_FROM = "#ffd89a";
const DEFAULT_GRADIENT_TO = "#e99400";

function normalizeCssColor(value: string | null | undefined): string | null {
  if (value == null) return null;
  const t = value.trim();
  if (!t) return null;
  if (/^(#|rgb|hsla?|linear-gradient|var\()/i.test(t)) return t;
  if (/^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$|^[0-9A-Fa-f]{8}$/.test(t)) return `#${t}`;
  if (/^\d+\s*,\s*\d+\s*,\s*\d+(\s*,\s*[\d.]+)?$/.test(t)) {
    return t.includes(",") && t.split(",").length === 4 ? `rgba(${t})` : `rgb(${t})`;
  }
  return t;
}

function tierGradientByKnownName(tierName: string | null | undefined): {
  from: string;
  to: string;
} {
  const key = tierName?.trim().toUpperCase() ?? "";
  if (!key) {
    return { from: DEFAULT_GRADIENT_FROM, to: DEFAULT_GRADIENT_TO };
  }
  if (key.includes("SILVER")) {
    return { from: "#bfcad9", to: "#0d2328" };
  }
  if (key.includes("LEGEND")) {
    return { from: "#fecfd9", to: "#e7031a" };
  }
  if (key.includes("GOLD")) {
    return { from: "#ffd89a", to: "#e99400" };
  }
  return { from: DEFAULT_GRADIENT_FROM, to: DEFAULT_GRADIENT_TO };
}

export function resolveMemberClubTierGradientColors(
  colorGradientFrom: string | null | undefined,
  colorGradientTo: string | null | undefined,
  tierName?: string | null
): { from: string; to: string } {
  let from = normalizeCssColor(colorGradientFrom);
  let to = normalizeCssColor(colorGradientTo);
  if (from && !to) to = from;
  if (!from && to) from = to;
  if (!from || !to) {
    return tierGradientByKnownName(tierName);
  }
  return { from, to };
}

export function memberClubCardTierBadgeBackground(
  colorGradientFrom: string | null | undefined,
  colorGradientTo: string | null | undefined,
  tierName?: string | null
): string {
  const { from, to } = resolveMemberClubTierGradientColors(
    colorGradientFrom,
    colorGradientTo,
    tierName
  );
  return `linear-gradient(90deg, ${from} 0%, ${to} 100%)`;
}

export function memberClubPillTierBadgeBackground(
  colorGradientFrom: string | null | undefined,
  colorGradientTo: string | null | undefined,
  tierName?: string | null
): string {
  const { from, to } = resolveMemberClubTierGradientColors(
    colorGradientFrom,
    colorGradientTo,
    tierName
  );
  return `linear-gradient(90deg, ${from} 0%, ${to} 100%)`;
}
